import styled from "styled-components";
import { palette } from "styled-theme";

const BreadCrumbsWrapper = styled.div`
  position: sticky;
  z-index: 9;
  display: block;
  .container {
    top: 0px;
    z-index: 2;
    padding: 0 16px;
    height: 100px;
    width: 100%;
    background-color: ${palette("surfaceColor", 0)};
    flex-direction: row;
    justify-content: space-between;
    display: flex;
  }
  .breadcrumbs {
    padding-top: 18px;
  }
  .ant-breadcrumb span {
    color: rgba(0, 0, 0, 0.45);
  }
  .ant-breadcrumb a {
    color: rgba(0, 0, 0, 0.45);
  }
  .ant-breadcrumb > span:last-child a {
    color: rgba(0, 0, 0, 0.45);
  }
  h1.ant-typography {
    margin: 8px 0;
  }
  .img {
    margin: 0px 20px 0px 50px;
    object-fit: contain;
    opacity: 0.85;
    width: auto;
    height: 100%;
    position: absolute;
    top: 0;
    left: 20px;
    left: ${(props) => (props["data-rtl"] === "rtl" ? "20px" : "inherit")};
    right: ${(props) => (props["data-rtl"] === "rtl" ? "inherit" : "20px")};
    &.withTabs {
      margin: 5px 20px 0px 50px;
      height: 140px;
    }
  }
  .status_badge {
    display: flex;
    align-items: center;
    margin: 0 20px 10px 20px;
    .ant-badge-status-dot {
      width: 12px;
      height: 12px;
    }
    .ant-badge-status-text {
      font-size: 20px;
    }
  }
`;

export default BreadCrumbsWrapper;
